import { Theme } from "@material-ui/core"
import FormControl from "@material-ui/core/FormControl"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import FormGroup from "@material-ui/core/FormGroup"
import Grid from "@material-ui/core/Grid"
import InputLabel from "@material-ui/core/InputLabel"
import makeStyles from "@material-ui/core/styles/makeStyles"
import Switch from "@material-ui/core/Switch"
import TextField from "@material-ui/core/TextField"
import React from "react"
import FieldSelect from "Components/Table/FieldSelect"
import ContentTypeSelect from "../WeiboTool/ContentTypeSelect"
import BoardConfirmModal from "../ConfirmModal/BoardConfirmModal"
import { useUpdateWeibo } from "./hooks"
import Button from "@material-ui/core/Button"

const useStyles = makeStyles((theme: Theme) => ({
    tagItem: {
        backgroundColor: "#00bcd4",
        padding: `4px 10px`,
        borderRadius: "14px",
        color: "white",
        margin: `10px ${theme.spacing(1)}px`,
        cursor: "pointer",
        boxSizing: "border-box",
        fontSize: 14,
        display: "inline-block",
        fontWeight: "bold",
    },
    input: {
        width: "100%",
        marginTop: 10,
    },
    materialBtn: {
        display: "flex",
        justifyItems: "flex-start",
        alignItems: "center",
        marginTop: 20,
        marginLeft: -5,
    },
}))

const WeiboUpdate = () => {
    const classes = useStyles()
    const {
        callback, cancelCallback, disabled,
        dialogData, board, text,
        handleChange,
        external,
        handleChangeArticleType,
        handleChangeMicro,
        handleChangeLottery,
        handleChangeContentType,
        editCallback,
    } = useUpdateWeibo()
    return (
        <BoardConfirmModal
            title="修改微博草稿"
            confirmCallback={callback}
            cancelCallback={cancelCallback}
            editCallback={editCallback}
            modalShow={dialogData.show}
            disabled={disabled}
        >
            <Grid container direction="column" justify="center">
                <TextField
                    label="内容"
                    value={text}
                    onChange={handleChange}
                />
                <Grid item>
                    <FormControl className={classes.input}>
                        <InputLabel>内容形式</InputLabel>
                        <ContentTypeSelect initialValue={board.content_type} onChange={handleChangeContentType} />
                    </FormControl>
                </Grid>
                <Grid item>
                    <FormControl className={classes.input}>
                        <InputLabel >文章类型</InputLabel>
                        <FieldSelect
                            rowData={{
                                article_type_id: external.articleTypeId,
                            }}
                            tableName="article_type"
                            onChange={handleChangeArticleType}
                            whereQuery={"where: {hidden: {_eq: false}}"}
                        />
                    </FormControl>
                </Grid>
                <Grid item>
                    <FormControl component="fieldset" className={classes.input}>
                        <FormGroup aria-label="position" row>
                            <FormControlLabel
                                value="抽奖"
                                control={
                                    <Switch
                                        color="primary"
                                        checked={external.isLottery}
                                        onChange={handleChangeLottery}
                                    />
                                }
                                label="抽奖"
                                labelPlacement="start"
                            />
                            <FormControlLabel
                                value="微任务"
                                control={
                                    <Switch
                                        color="primary"
                                        checked={external.isMicro}
                                        onChange={handleChangeMicro}
                                    />
                                }
                                label="微任务"
                                labelPlacement="start"
                            />
                        </FormGroup>
                    </FormControl>
                </Grid>
                <Grid item>
                    <div className={classes.materialBtn}>
                        <Button color="primary" onClick={editCallback}>编辑物料</Button>
                    </div>
                </Grid>
            </Grid>
        </BoardConfirmModal>
    )
}

export default WeiboUpdate
